import React from "react";
import PropTypes from "prop-types";
import { ModalClosed, RefreshIcon, WarningIcon2 } from "~misc/icons";

const ModalSync = ({ isOpen, onClose, title, sub, className, onClick, buttonLabel = "Sincronizar dados" }) => {
  const modalClasses = isOpen ? `fixed inset-0 bg-black bg-opacity-50 z-[999999]` : "hidden";
  const overlayClasses = isOpen ? `fixed inset-0 bg-black opacity-50 z-40` : "hidden";

  return (
    <div className={modalClasses} data-testid="modal-overlay">
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div
          className={`flex justify-center items-center flex-col bg-white px-14 py-10 rounded-[20px] shadow-lg z-50 text-center relative ${className ?? ""}`}
          data-testid="modal"
          role="dialog"
          aria-modal="true"
        >
          <WarningIcon2 fill="#DC2626" />
          {onClose && (
            <div className="flex justify-end mt-4">
              <button
                type="button"
                onClick={onClose}
                className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                data-test-id="modal-sync-close-button"
                aria-label="Fechar modal"
              >
                <ModalClosed />
              </button>
            </div>
          )}
          <h3 className="font-bold text-xl ">{title}</h3>
          <div className="my-4 w-full flex justify-center items-center" data-testid="modal-content">
            <p className="max-w-[400px] font-semibold">{sub}</p>
          </div>
          <div className="flex justify-center gap-3">
            <button onClick={onClick} id="synchronize-button">
              <RefreshIcon />
              <span>{buttonLabel}</span>
            </button>
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>
  );
};

ModalSync.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  sub: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
};

export default ModalSync;
